module.exports = __webpack_public_path__ + "img/podstawienie.b3008a95.svg";